// client/src/lib/invoiceLinks.ts
/**
 * Platform invoices carry a client link `/inv/<64-hex token>`; the token alone authorises the public
 * `/api/inv/<token>` routes (summary, /pdf, /receipt/:id), so the system browser can open them with no
 * session cookie. Legacy Zoho rows have no token. Pure — shared by InvoiceModal and pages/invoices.tsx.
 */
export function invTokenFromUrl(paymentUrl: string | null | undefined): string | null {
  if (!paymentUrl) return null;
  const m = /\/inv\/([0-9a-f]{64})/.exec(paymentUrl);
  return m ? m[1] : null;
}

/** `/api/inv/<token>/pdf` for a platform invoice link, else null. */
export function invoicePdfPath(paymentUrl: string | null | undefined): string | null {
  const t = invTokenFromUrl(paymentUrl);
  return t ? `/api/inv/${t}/pdf` : null;
}

/**
 * Where "Download PDF" goes in the app: the tokenised PDF in the system browser (a blob + a.download
 * does nothing in WKWebView). null = keep the existing blob download (always on the web; a legacy row
 * without a token in the app too — its PDF route needs the session).
 */
export function appInvoiceDownloadTarget(app: boolean, paymentUrl: string | null | undefined): string | null {
  return app ? invoicePdfPath(paymentUrl) : null;
}
